import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";


const ContactThankYou = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Contact</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        Thank you, your message has been submitted successfully. Someone from the Porchfest committee will be in touch.
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ContactThankYou;
